import { useQuery } from "react-query";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../firebase.init";

const API_BASE = process.env.REACT_APP_apiHostLink;

export const useAuditLogs = (params = {}) => {
  const [user] = useAuthState(auth);

  const queryString = new URLSearchParams({
    page: params.page || 1,
    limit: params.limit || 20,
    ...(params.search && { search: params.search }),
    ...(params.targetType && { targetType: params.targetType }),
    ...(params.action && { action: params.action }),
  }).toString();

  return useQuery(
    ["audit-logs", params],
    async () => {
      const token = await user.getIdToken();
      const res = await fetch(`${API_BASE}/api/admin/audit-logs?${queryString}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch audit logs");
      return res.json();
    },
    { enabled: !!user, keepPreviousData: true }
  );
};
